var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:['button-wrap', _vm.classObject]},_vm.$listeners),[_c('div',{staticClass:"button"},[_vm._t("default"),_c(_vm.icon,{tag:"component",staticClass:"icon",class:{'icon-left': _vm.iconLeft}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }